"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Narrative() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const milestones = [{
    year: "2018",
    label: "Consulting"
  }, {
    year: "2020",
    label: "Strategy"
  }, {
    year: "2022",
    label: "Growth"
  }, {
    year: "2024",
    label: "Authority"
  }];
  return <section data-section-id="789" id="the-narrative" className="relative overflow-hidden bg-background text-foreground py-24 md:py-32 lg:py-[180px]">
      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs uppercase tracking-[0.25em] text-primary" style={{
          color: "var(--primary)"
        }}>
            — The Origin
          </p>
          <h2 className="mt-8 font-default text-3xl font-medium leading-[0.9] tracking-[0.15em] text-foreground sm:text-4xl md:text-5xl lg:text-[4rem]">
            BEYOND THE
            <br />
            NOISE OF THE
            <br />
            DIGITAL AGE.
          </h2>
          <div className="mx-auto mt-10 h-16 w-px" style={{
          backgroundColor: "var(--primary)"
        }} aria-hidden="true" />
        </div>

        {}
        <div ref={contentRef} className={`mt-20 grid grid-cols-1 gap-12 transition-all duration-1000 ease-out lg:mt-28 lg:grid-cols-12 lg:gap-16 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="relative overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/myles_dacres_studio.png" alt="Myles Dacres in a minimalist creative workspace" loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover" />
              </div>
              <p className="mt-4 font-default text-xs uppercase tracking-[0.25em]" style={{
              color: "var(--muted-foreground)"
            }}>
                MD-01: THE STUDIO
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="max-w-2xl space-y-8">
              {}
              <p className="text-lg leading-[1.6] text-foreground">
                <span className="float-left mr-3 mt-1 font-default text-[5.5rem] font-medium leading-[0.85] text-primary" style={{
                color: "var(--primary)"
              }}>
                  B
                </span>
                uilding a lasting authority requires more than visibility; it demands a distinct point of view. In an ecosystem saturated with noise, true influence comes from uncompromising clarity and deliberate positioning. We partner with founders to distill their core philosophy into an undeniable market presence.
              </p>

              {}
              <div className="my-12 border-y py-8 text-center" style={{
              borderColor: "var(--border)"
            }}>
                <p className="font-default text-2xl font-medium italic leading-snug md:text-[1.5rem]" style={{
                color: "var(--primary)"
              }}>
                  "Visibility is the byproduct of genuine value."
                </p>
              </div>

              {}
              <p className="text-lg leading-[1.6] text-foreground">
                Strategy is not about doing more; it is about eliminating the non-essential until only the exceptional remains. Every touchpoint should reinforce your authority and invite meaningful engagement from the clients who matter most.
              </p>

              {}
              <p className="text-lg leading-[1.6] text-foreground">
                The work we do together is designed to endure. By establishing rigorous standards and a cohesive narrative, we position your brand not just as a participant in your industry, but as its definitive leader.
              </p>

              {}
              <div className="pt-2">
                <p className="font-default text-3xl font-medium" style={{
                color: "var(--primary)"
              }}>
                  Myles Dacres
                </p>
              </div>
            </div>
          </div>
        </div>

        {}
        <div ref={timelineRef} className={`mt-24 transition-all duration-1000 ease-out lg:mt-32 ${timelineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="relative">
            <div className="absolute left-0 right-0 top-1/2 h-px -translate-y-1/2" style={{
            backgroundColor: "var(--primary)",
            opacity: 0.4
          }} aria-hidden="true" />
            <div className="relative -mx-6 overflow-x-auto px-6 md:mx-0 md:overflow-visible md:px-0">
              <div className="grid min-w-[640px] grid-cols-4 gap-6 md:min-w-0">
                {milestones.map((milestone, i) => <div data-index={i} key={milestone.year} className="relative flex flex-col items-center text-center">
                    <p className="font-default text-3xl font-medium md:text-4xl" style={{
                  color: "var(--primary)"
                }}>
                      {milestone.year}
                    </p>
                    <div className="my-4 h-3 w-px" style={{
                  backgroundColor: "var(--primary)"
                }} aria-hidden="true" />
                    <p className="font-default text-xs uppercase tracking-[0.25em] text-foreground">
                      {milestone.label}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute -bottom-8 -right-12 select-none overflow-hidden md:-bottom-16 md:-right-20 lg:-bottom-24 lg:-right-32" aria-hidden="true">
        <p className="font-default text-[18vw] font-bold leading-none tracking-widest md:text-[16vw] lg:text-[14vw]" style={{
        color: "var(--card)",
        opacity: 0.5
      }}>
          MYLES
        </p>
      </div>
    </section>;
}